import {
  Box,
  Divider,
  FormControl,
  FormHelperText,
  TextField,
} from "@mui/material";
import { AddCircleOutline } from "@mui/icons-material";

import { useVerification } from "../../../../../context/Verification.context";
import ArtifactButton from "../../../../base/dialog-body/ArtifactButton.component";
import Theme from "../../../../../utils/Theme";
import { InputValidation } from "../../../../../utils/InputValidationRegex";
import { ArtifactStyle } from "./VerficationArtifactsStyles";
import AppButton from "../../../../base/AppButton.component";
import { SUBMIT_REFERRAL } from "../../../../../graphql/mutation/mutation";
import { useState } from "react";
import { useMutation, useQuery } from "@apollo/client";
import { FETCH_REFERRAL_DETAILS } from "../../../../../graphql/query/query";

const ReferralResponse = ({
  artifact,
  handleTextChange,
  handleUser,
  isAIReview,
}) => {
  const verification = useVerification();

  const [success, setSuccess] = useState(false);

  const [submitReferral, { loading: updateLoading }] =
    useMutation(SUBMIT_REFERRAL);
  const submitHandler = () => {
    const refUsers = verification.artifactsResponse.referralResponse.map(
      (item) => ({
        name: item.name,
        mobile_number: item.mobile_number,
      }),
    );

    submitReferral({
      variables: {
        referralInput: {
          user_id: parseInt(verification.customer.userId),
          refUsers: refUsers, 
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          dealership_id: parseInt(verification.dealershipId),
          employee_user_id: parseInt(verification?.employeeId),
        },
      },
    });
  };
  // console.log("REFUSERS", verification);
  console.log("refUser", verification.artifactsResponse.referralResponse);
  return (
    <Box
      sx={{
        display: "flex",
        width: "90%",
        justifyContent: "center",
        alignItems: "center",
        mt: 1,
        //  border: "2px solid grey",
        //  borderRadius: "8px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",

          width: window.innerWidth <= 750 ? "90%" : "100%",
          justifyContent: "center",
          alignItems: "center",
          gap: 1,
        }}
      >
        {verification.artifactsResponse?.referralResponse?.map(
          (item, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",

                width: window.innerWidth <= 750 ? "90%" : "100%",
                border: "2px solid grey",
                borderRadius: "6px",
                padding: "12px",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: window.innerWidth <= 750 ? "column" : "row",
                gap: window.innerWidth <= 750 ? "8px" : "16px",
                backgroundColor: isAIReview ? "white" : "transparent",
                position: "relative",
              }}
            >
              {/* NAME FIELD */}
              <FormControl fullWidth sx={{ mb: -1 }}>
                <TextField
                  label={verification.aiData.spanish ? "Nombre" : "Name"}
                  fullWidth
                  value={item.name}
                  size="small"
                  onChange={(e) =>
                    handleTextChange(
                      index,
                      "name",
                      e.target.value,
                      artifact?.id,
                    )
                  }
                  error={InputValidation.nameValidation(item.name)}
                  sx={{
                    mt: 0.25,
                    mb: 0,
                    "& label": {
                      color: InputValidation.nameValidation(item.name)
                        ? Theme.palette.error.main
                        : Theme.palette.primary.main,
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: InputValidation.nameValidation(item.name)
                          ? Theme.palette.error.main
                          : Theme.palette.primary.main,
                      },
                      "&:hover fieldset": {
                        borderColor: InputValidation.nameValidation(item.name)
                          ? Theme.palette.error.main
                          : Theme.palette.primary.main,
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: InputValidation.nameValidation(item.name)
                          ? Theme.palette.error.main
                          : Theme.palette.primary.main,
                      },
                    },
                  }}
                />
                <FormHelperText
                  sx={{ color: Theme.palette.error.main, fontSize: "10px" }}
                >
                  {InputValidation.nameValidation(item.name)
                    ? verification.aiData.spanish
                      ? "Por favor, introduzca un nombre válido?"
                      : "Please enter a valid name"
                    : " "}
                </FormHelperText>
              </FormControl>

              {/* MOBILE NUMBER FIELD */}
              <FormControl
                fullWidth
                sx={{
                  mb: -1,

                  width: {
                    xs: index === 0 ? "70%" : "100%", // mobile (<= 600 by default)
                    sm: index === 0 ? "70%" : "100%", // extend up to ~750
                    md: index === 0 ? "85%" : "100%", // iPad mini range
                    lg: "100%", // desktop
                  },

                  alignSelf: "flex-start",
                }}
              >
                <TextField
                  label={
                    verification.aiData.spanish
                      ? "Número de teléfono móvil"
                      : "Mobile Number"
                  }
                  fullWidth
                  value={InputValidation.phoneNumberFormat(
                    item.mobile_number || "",
                  )}
                  size="small"
                  onChange={(e) =>
                    handleTextChange(
                      index,
                      "mobile_number",
                      e.target.value,
                      artifact?.id,
                    )
                  }
                  error={InputValidation.numberValidation(
                    item.mobile_number || "",
                  )}
                  sx={{
                    mt: 0.25,
                    mb: 0,
                    "& label": {
                      color: InputValidation.numberValidation(
                        item.mobile_number,
                      )
                        ? Theme.palette.error.main
                        : Theme.palette.primary.main,
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: InputValidation.numberValidation(
                          item.mobile_number,
                        )
                          ? Theme.palette.error.main
                          : Theme.palette.primary.main,
                      },
                      "&:hover fieldset": {
                        borderColor: InputValidation.numberValidation(
                          item.mobile_number,
                        )
                          ? Theme.palette.error.main
                          : Theme.palette.primary.main,
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: InputValidation.numberValidation(
                          item.mobile_number,
                        )
                          ? Theme.palette.error.main
                          : Theme.palette.primary.main,
                      },
                    },
                  }}
                />
                <FormHelperText
                  sx={{
                    color: Theme.palette.error.main,
                    fontSize: "10px",
                  }}
                >
                  {InputValidation.numberValidation(item.mobile_number)
                    ? verification.aiData.spanish
                      ? "Por favor, introduzca un número válido"
                      : "Please enter a valid number"
                    : " "}
                </FormHelperText>
              </FormControl>

              {/* Add New Button below Mobile Number field on mobile */}
              {window.innerWidth <= 750 && index === 0 && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "end",
                    width: "90%",
                    // ml: 18,
                  }}
                >
                  <AppButton
                    variant={"text"}
                    buttonText={"Add New"}
                    size={"medium"}
                    sx={{
                      textDecoration: "underline",
                      padding: 0,
                      minWidth: "auto",
                      fontSize: "0.65rem",
                      mt: -6,
                      ml: 1.2,
                    }}
                    clickHandler={() => handleUser()}
                  />
                </Box>
              )}

              {/* Divider and Add New Button - ONLY FOR FIRST ITEM ON DESKTOP */}
              {index === 0 && window.innerWidth > 750 && (
                <>
                  <Divider orientation="vertical" flexItem />

                  {/* ADD NEW */}
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      cursor: "pointer",
                      gap: 0.5,
                      whiteSpace: "nowrap",
                      ml: "auto",
                      mt: -1,
                    }}
                  >
                    <AppButton
                      variant={"text"}
                      buttonText={"Add New"}
                      size={"medium"}
                      sx={{
                        textDecoration: "underline",
                        padding: 0,
                        minWidth: "auto",
                        fontSize: "0.75rem",
                      }}
                      clickHandler={() => handleUser()}
                    />
                  </Box>
                </>
              )}
            </Box>
          ),
        )}
      </Box>
    </Box>
  );
};

export default ReferralResponse;
